import { requestAesPost5 } from "@/libsV2/requestAes.js";
import { data } from "jquery";

const URL = {
    USER_APPINDEX_INDEX: "member/appindex/index", // 用户交付在线首页
    BANNER: 'ssp/adment/info', // 广告Banner
    PROJECT_LOG: 'project/report/projectlog',//获取项目日志
    USER_TEAM_V2: "member/project/teamv2", // 服务团队
    USER_PROJECT_LIST: "member/project/lists", // 用户我的项目列表
    GET_LIST: 'discuss.indexv2/completed_list', //竣工评价展示
    USER_SET_PACT: "member/index/setDefault", // 用户设置默认合同
    NOTI_INDEX_NOTIFY: 'notification/Index/getNotify', // 我的消息
    NOTI_INDEX_CHANGE: 'notification/index/change',//已读消息
    MEMORANDUM: "contract/index/getInfo",    // 交付在线-订单备忘录
    DOWNLOAD: "contract/index/getContantFile",//合同下载
    TAGLIST: "discuss.indexv2/tag_list", //五星标签
    OSSCONFIG: "discuss.ossconfig/getConfig", //oss
    RESUBMIT: "discuss.indexv2/discuss_add", //添加追加评价
    MEBER_LISTS_V2: 'member/process/listsv2',//交付报告列表2.0
    MEMBER_PROCESS_INFOV2    : 'member/process/infov2',//交付详情2.0
    SENDSERVICE_ID: 'member/access/video',
    GET_INFO: 'user/index/index',//用户信息
    GET_AGREE: 'agree/index/info',//隐私协议
    GET_RANDS: 'project/index/rands',//根据城市随机取三个案例
    GET_REPORTINFO: 'wind/index/reportinfo',//报告详情
    GET_POSLISTS: 'ssp/adment/poslists',//广告位
    VRLIST: 'shop/vr/fas',//VR列表
    GET_CHECK: 'parts/index/check',//展示报价单
    CLEAR_APP_NOTIFY: '/notification/Index/clearappnotify', // 刷新爱暖通app消息标记
    GET_PROJECT_TYPE: 'discuss.indexv2/getprojecttype', //判断是否是五恒案例
};
export const projectType = (data = {}) => {
    return requestAesPost5(URL.GET_PROJECT_TYPE, data)
}
export const getCheck = (data = {}) => {
    return requestAesPost5(URL.GET_CHECK, data)
}
export const getVrList = (data = {}) => {
    return requestAesPost5(URL.VRLIST, data)
}

export const getPoslists = (data = {}) => {
    return requestAesPost5(URL.GET_POSLISTS, data)
}

export const getReportinfo = (data = {}) => {
    return requestAesPost5(URL.GET_REPORTINFO, data)
}

export const getRanks = (data = {}) => {
    return requestAesPost5(URL.GET_RANDS, data)
}

export const getAgree = (data = {}) => {
    return requestAesPost5(URL.GET_AGREE, data)
}

export const getInfo = (data = {}) => {
    return requestAesPost5(URL.GET_INFO, data)
}

export const sendSeriveId = (data = {}) => {
    return requestAesPost5(URL.SENDSERVICE_ID, data)
}

export const processInfoV2 = (data = {}) => {
    return requestAesPost5(URL.MEMBER_PROCESS_INFOV2, data)
}

export const evaInfo = (data = {}) => {
    return requestAesPost5(URL.GET_LIST, data)
}

export const memberlistV2 = (data = {}) => {
    return requestAesPost5(URL.MEBER_LISTS_V2, data)
}

export const discussAdd = (data = {}) => {
    return requestAesPost5(URL.RESUBMIT, data)
}

export const reSubmit = (data = {}) => {
    return requestAesPost5(URL.RESUBMIT, data)
}

export const ossconfig = (data = {}) => {
    return requestAesPost5(URL.OSSCONFIG, data)
}

export const tagList = (data = {}) => {
    return requestAesPost5(URL.TAGLIST, data)
}

export const downloadContract = (data = {}) => {
    return requestAesPost5(URL.DOWNLOAD, data);
};

export const getMemorandumInfo = (data = {}) => {
    return requestAesPost5(URL.MEMORANDUM, data);
};

export const getUserAppIndex = (data = {}) =>{
    return requestAesPost5(URL.USER_APPINDEX_INDEX, data)
}

export const getChange = (data = {}) => {
    return requestAesPost5(URL.NOTI_INDEX_CHANGE, data);
}

export const getNotify = (data = {}) => {
    return requestAesPost5(URL.NOTI_INDEX_NOTIFY, data);
}

export const getAppBanner = (data = {}) =>{
    return requestAesPost5(URL.BANNER, data)
}

export const getProjectLog = (data = {}) =>{
    return requestAesPost5(URL.PROJECT_LOG, data)
}

export const getTeamV2 = (data = {}) =>{
    return requestAesPost5(URL.USER_TEAM_V2, data)
}

export const getProectList = (data = {}) =>{
    return requestAesPost5(URL.USER_PROJECT_LIST, data)
}

export const getAppProectList = (data = {}) =>{
    return requestAesPost5(URL.USER_PROJECT_LIST, data)
}

export const getList = (data = {}) => {
    return requestAesPost5(URL.GET_LIST, data)
}

export const getSetPact = (data = {}) =>{
    return requestAesPost5(URL.USER_SET_PACT, data)
}

export const clearAppPost = (data = {}) =>{
    return requestAesPost5(URL.CLEAR_APP_NOTIFY, data)
}
